import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const GoldText = styled('span')(({ theme }) => ({
    color: '#D4AF37',
    fontWeight: 600,
}));

const AccentLine = styled(Box)(({ theme }) => ({
    width: '80px',
    height: '4px',
    background: 'linear-gradient(to right, #D4AF37, #FFB800)',
    borderRadius: '2px',
    margin: '0 auto 24px auto',
}));

interface TypographyProps {
    children: React.ReactNode;
    className?: string;
    sx?: any;
}

export const MemerH1: React.FC<TypographyProps> = ({ children, className, sx }) => (
    <Typography variant="h1" className={className} sx={sx}>
        {children}
    </Typography>
);

export const MemerH2: React.FC<TypographyProps> = ({ children, className, sx }) => (
    <Typography variant="h2" className={className} sx={sx}>
        {children}
    </Typography>
);

export const MemerH3: React.FC<TypographyProps> = ({ children, className, sx }) => (
    <Typography variant="h3" className={className} sx={sx}>
        {children}
    </Typography>
);

export const MemerH4: React.FC<TypographyProps> = ({ children, className, sx }) => (
    <Typography variant="h4" className={className} sx={sx}>
        {children}
    </Typography>
);

export const MemerBody: React.FC<TypographyProps> = ({ children, className }) => (
    <Typography variant="body1" className={className}>
        {children}
    </Typography>
);

export const MemerBodyLarge: React.FC<TypographyProps> = ({ children, className }) => (
    <Typography variant="body1" sx={{ fontSize: '1.2rem' }} className={className}>
        {children}
    </Typography>
);

export const MemerBodySmall: React.FC<TypographyProps> = ({ children, className }) => (
    <Typography variant="body2" className={className}>
        {children}
    </Typography>
);

export const MemerGoldText: React.FC<TypographyProps> = ({ children, className }) => (
    <GoldText className={className}>
        {children}
    </GoldText>
);

export const MemerAccentLine: React.FC<{ className?: string }> = ({ className }) => (
    <AccentLine className={className} />
);
